import { z } from 'zod';
export const createCampaignSchema = z.object({
    name: z.string().trim().min(2).max(150),
    description: z.string().trim().max(2000).optional(),
});
export const updateCampaignSchema = createCampaignSchema.partial();
export const campaignSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    fieldSessionCount: z.number().int().nonnegative(),
    videoCount: z.number().int().nonnegative(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
/**
 * Une session de vol représente une sortie de vol. Les champs `pilotName` et `aircraftModel` sont
 * saisis manuellement : la télémétrie ne les porte pas de façon fiable selon les constructeurs.
 */
export const createFieldSessionSchema = z.object({
    campaignId: z.string().cuid2(),
    name: z.string().trim().min(2).max(150),
    description: z.string().trim().max(2000).optional(),
    flownAt: z.coerce.date().optional(),
    pilotName: z.string().trim().max(100).optional(),
    aircraftModel: z.string().trim().max(100).optional(),
    /**
     * Matériel de captation de la flotte (drone/UGV) rattaché à la sortie — traçabilité ADR-0029.
     * `null` dissocie explicitement ; champ absent = inchangé (sémantique PATCH).
     */
    assetId: z.string().cuid2().nullable().optional(),
    /** Lieu en clair, complémentaire de la géolocalisation dérivée de la télémétrie. */
    locationName: z.string().trim().max(200).optional(),
    /** Contributeurs de la sortie (pilotes, observateurs…), saisis en clair. */
    contributors: z.array(z.string().trim().min(1).max(100)).max(50).default([]),
});
// `campaignId` reste modifiable : rattacher une session de vol à une autre campagne.
export const updateFieldSessionSchema = createFieldSessionSchema.partial();
export const fieldSessionSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    campaignId: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    flownAt: z.coerce.date().nullable(),
    pilotName: z.string().nullable(),
    aircraftModel: z.string().nullable(),
    /** Identifiant du matériel de captation rattaché (ADR-0029), ou `null`. */
    assetId: z.string().nullable(),
    /** Nom du matériel rattaché, joint pour l'affichage (évite une requête par session). */
    assetName: z.string().nullable(),
    locationName: z.string().nullable(),
    contributors: z.array(z.string()),
    videoCount: z.number().int().nonnegative(),
    totalDurationSeconds: z.number().nonnegative(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
//# sourceMappingURL=campaign.js.map